import React, { useContext, useState } from "react";
import { CartContext } from "../components/CartContext";
import { Link } from "react-router-dom";
import "../css/cartPage.css";

export default function CartPage() {
  const { cartItems, increaseQuantity, decreaseQuantity, removeFromCart, clearCart } =
    useContext(CartContext);

  const [voucher, setVoucher] = useState("");
  const [discount, setDiscount] = useState(0);
  const [promoMsg, setPromoMsg] = useState("");
  const [promoType, setPromoType] = useState(""); // success or error

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  const deliveryFee = subtotal >= 100 ? 0 : 50;
  const total = subtotal - discount + deliveryFee;

  const applyVoucher = () => {
    const code = voucher.trim().toUpperCase();

    if (code === "SAVE10") {
      const discountValue = subtotal * 0.1;
      setDiscount(discountValue);
      setPromoMsg(`Promo code applied successfully! You saved $${discountValue.toFixed(2)}.`);
      setPromoType("success");
    } else if (code === "") {
      setPromoMsg("Please enter a promo code.");
      setPromoType("error");
    } else {
      setDiscount(0);
      setPromoMsg("Incorrect promo code. Please try again.");
      setPromoType("error");
    }
  };

  // ✅ Handle Empty Cart
  if (cartItems.length === 0) {
    return (
      <div className="empty-cart-container">
        <h3>Your Cart is Empty</h3>
        <p>Looks like you haven’t added anything yet. Start shopping now!</p>
        <Link to="/"><button className="btn btn-dark">Continue Shopping</button></Link>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <div className="cart-left">
        <table className="cart-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Quantity</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {cartItems.map((item, i) => (
              <tr key={i}>
                <td className="cart-product">
                  <img src={item.image} alt={item.name} className="cart-thumb" />
                  <div>
                    <h5>{item.name}</h5>
                  </div>
                </td>

                <td>
                  <div className="qty-controls">
                    <button onClick={() => decreaseQuantity(item)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => increaseQuantity(item)}>+</button>
                  </div>
                </td>

                <td>${(item.price * item.quantity).toFixed(2)}</td>

                <td>
                  <i
                    className="fa-solid fa-trash delete-icon"
                    onClick={() => removeFromCart(item)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ✅ Changed Update Cart to Clear Cart */}
        <button className="btn btn-dark rounded-pill clear-btn mt-3" onClick={clearCart}>
          Clear Cart <i className="fa-solid fa-trash mx-1"></i>
        </button>
      </div>

      <div className="cart-right" style={{ maxHeight: '400px' }}>
        <h4>Order Summary</h4>

        <div className="voucher-box">
          <input
            type="text"
            placeholder="Discount voucher"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
          <button onClick={applyVoucher}>Apply</button>
        </div>

        {promoMsg && (
          <div
            className={`promo-alert ${promoType === "success" ? "success" : "error"}`}
          >
            {promoMsg}
          </div>
        )}

        <div className="summary-details">
          <div className="summary-line">
            <span>Sub Total</span>
            <span>${subtotal.toFixed(2)} USD</span>
          </div>

          <div className="summary-line">
            <span>Discount</span>
            <span>- ${discount.toFixed(2)} USD</span>
          </div>

          <div className="summary-line">
            <span>Delivery Fee</span>
            <span>${deliveryFee.toFixed(2)} USD</span>
          </div>

          <div className="summary-total">
            <span>Total</span>
            <strong>${total.toFixed(2)} USD</strong>
          </div>
        </div>

        <Link to="/checkout">
          <button className="checkout-btn mt-4">Checkout Now</button>
        </Link>
      </div>
    </div>
  );
}
